(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-more-info"] && !Shopify.designMode) return;
  try {
    
  function initializeCollectionMoreInfo(root) {
    var sections = root.querySelectorAll('[data-collection-more-info]');

    sections.forEach(function (section) {
      if (section.dataset.initialized === 'true') return;

      var content = section.querySelector('[data-more-info-content]');
      var button = section.querySelector('[data-more-info-toggle]');
      var label = section.querySelector('[data-more-info-label]');

      if (!content || !button || !label) return;

      section.dataset.initialized = 'true';

      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        content.classList.toggle('is-expanded', !expanded);
        label.textContent = expanded ? 'Mehr erfahren' : 'Weniger anzeigen';
      });
    });
  }

  initializeCollectionMoreInfo(document);

  document.addEventListener('shopify:section:load', function (event) {
    initializeCollectionMoreInfo(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
